
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Calendar from "../../components/Calendar/Calendar";

export const CalendarPage = () => {

  return (
    <div >
      <Header/>
      <Calendar/>
      <Footer/>
    </div>

  );
};

